import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { MacroBucket } from '../lib/ingredientRegistry'
import type { QualityPreference } from '../lib/groceryPrices'

export function useShoppingCopy() {
  const { t } = useTranslation()

  const macroBucketLabel = useCallback(
    (bucket: MacroBucket) => t(`shopping.macros.${bucket}`),
    [t],
  )

  const qualityOptions = useMemo(
    (): { id: QualityPreference; label: string }[] => [
      { id: 'bio', label: t('shopping.quality.bio') },
      { id: 'non-bio', label: t('shopping.quality.nonBio') },
      { id: 'mix', label: t('shopping.quality.mix') },
    ],
    [t],
  )

  return { macroBucketLabel, qualityOptions, t }
}
